//$('.boxNewsletter').css('top','15px');


localStorage.setItem('nameserver', 'https://kometsales.com');



$(window).scroll(function() {

 
  
 
if(localStorage.getItem('main')!='blogShopify'){
  
  /* 
    if ($(this).scrollTop() > 400) {
  	$('#shopify-section-header').addClass('HeaderBottom');
  }else{
    $('#shopify-section-header').removeClass('HeaderBottom');
  }
  */

  
  /*
        
       if ($(this).scrollTop() > 400) {
          	$('#shopify-section-headerSpanish').addClass('menu-theme-bottom');
          	$('#shopify-section-header').addClass('menu-theme-bottom');          
            $('#logoBottom').addClass('Visible');  
            $('.logoTop').addClass('noVisible');  
            $('#shopify-section-header form').addClass('FormMenuBottom');
            $('#shopify-section-headerSpanish form').addClass('FormMenuBottom');
            $('#SignInIcon').attr('src','https://d2crhp0mf8xrz.cloudfront.net/assets/icon-singin-b.png');
 			$('.singin span').css('color','#4d4d4d');
            $('.btn-language').addClass('blackFont');

        } else {
            $('.logoTop').removeClass('noVisible');          
          	$('#shopify-section-header').removeClass('menu-theme-bottom');
		    $('#shopify-section-header form').removeClass('FormMenuBottom'); 
            $('#shopify-section-headerSpanish').removeClass('menu-theme-bottom');
		    $('#shopify-section-headerSpanish form').removeClass('FormMenuBottom'); 
            $('#SignInIcon').attr('src',' https://d2crhp0mf8xrz.cloudfront.net/assets/icon-singin.png');
 			$('.singin span').css('color','#fff');
            $('#logoBottom').removeClass('Visible'); 
            $('.btn-language').removeClass('blackFont');         
        }
        */
  }
  
  
if(localStorage.getItem('main')=='resourcesShopify'){
       
  
         if ( ( $(this).scrollTop() > 460  ) &&  ( $(this).scrollTop() < 1270  ) ){
            var totalScroll = (($(this).scrollTop()-460)+15);
            $('.boxNewsletter.spanish').css('top',totalScroll+'px');
            
          }
   
       
      
          if ( ( $(this).scrollTop() > 460  ) &&  ( $(this).scrollTop() < 1830  ) ){
            var totalScroll = (($(this).scrollTop()-460)+15);
            $('.boxNewsletter.english').css('top',totalScroll+'px');
            
          }
   
         if ( ( $(this).scrollTop() < 460  )  ){
            $('.boxNewsletter.english').css('top','15px');
            $('.boxNewsletter.spanish').css('top','15px');
            $('.boxNewsletter.TrainingsEnglish').css('top','0px');


          }
      
  
  
         if ( ( $(this).scrollTop() > 460  ) &&  ( $(this).scrollTop() < 646  ) ){
            var totalScroll = (($(this).scrollTop()-460)+1);
            $('.boxNewsletter.TrainingsEnglish').css('top',totalScroll+'px');
            
          }
   
  
  
  
  
  
}
 
  
  
});